import React, {useEffect, useState} from "react"
import {useParams} from "react-router-dom"

import {Card, Loading} from "@components/index"
import {UserInfo} from "@modules/user/components/UserInfo"
import {IGame, IGamePlay, IQuestion, IUser,} from "@backend/types"

import {BattleModeHistory, GamePlayStatusBadge} from "../../components"
import {gamePlayApiCalls} from "../../service"

function Stat({title, content}) {

    return <div className="px-4 py-6 sm:px-6 lg:px-8">
        <p className="text-sm font-medium leading-6">{title}</p>
        <p className="mt-2 flex items-baseline gap-x-2">
         <span className="text-xl font-semibold tracking-tight ">
         {content}
          </span>
        </p>
    </div>
}

export function GamePlayDetails() {
    const {gamePlayId} = useParams()
    const [gamePlay, setGamePlay] = useState<IGamePlay | null>()

    useEffect(() => {
        gamePlayApiCalls.apiCalls.getOne(gamePlayId).then(setGamePlay)
    }, [])

    if (!gamePlay)
        return <Loading/>

    const {modeOptions, info} = (gamePlay.gameId as IGame)

    if (modeOptions?.mode !== "battle")
        return <div>Battle mode only!</div>

    const {questionIds = [], fields = []} = modeOptions || {}
    const {voteData = {}} = gamePlay

    const totalQuestionCount = questionIds.length
    const fieldCount = fields.length
    const userVoteCount = Object.keys(voteData || {}).reduce((acc, key) => {
        acc = acc + (voteData[key] || []).length
        return acc
    }, 0)
    const totalVoteCount = (((fieldCount - 2) * (fieldCount - 1)) / 2) * totalQuestionCount

    return <Card
        bodyClassName="p-0"
        title="Game Play Stats"
        badge={<GamePlayStatusBadge status={gamePlay.completeStatus}/>}
        subTitle={`Started: ${(new Date(gamePlay.createdAt)).toDateTime(true)}`}
        actions={<UserInfo user={gamePlay.userId as IUser}/>}
    >
        <div>
            <div className="grid grid-cols-2 lg:grid-cols-4">

                <Stat
                    title="Game"
                    content={info?.title}
                />

                <Stat
                    title="Questions Completed"
                    content={`${Math.max(0, Object.keys(voteData).length - 1)}/${totalQuestionCount}`}
                />

                <Stat
                    title="Vote Count"
                    content={`${userVoteCount} / ${totalVoteCount}`}
                />

                <Stat
                    title="Progress"
                    content={`%${Math.round((userVoteCount / totalVoteCount) * 100)}`}
                />
            </div>


            <div className="border-t pt-2 px-4 py-6 sm:px-6 lg:px-8">
                <h2 className="text-base font-semibold leading-7">Votes</h2>
                {gamePlay.voteData && Object.keys(gamePlay.voteData).length > 0 &&
                  <BattleModeHistory
                    fields={fields}
                    questionIds={questionIds as IQuestion[]}
                    voteData={gamePlay.voteData}/>}
            </div>
        </div>
    </Card>
}